import React from 'react';

interface NagConfigurationProps {
    configuration: {
        BaseUrl?: string;
        Hash?: string;
        Timeout?: number;
    };
    onChange: (field: string, value: string | number) => void;
    disabled?: boolean;
}

interface NagConfigurationComponent extends React.FC<NagConfigurationProps> {
    configFields: string[];
}

const NagConfiguration: NagConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🌐</span>
                    Базовый URL
                </label>
                <div className="input-group-custom">
                    <input
                        type="url"
                        className="form-input-custom"
                        value={configuration.BaseUrl || ''}
                        onChange={(e) => onChange('BaseUrl', e.target.value)}
                        placeholder="https://b2b.nag.ru"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🔑</span>
                    API Ключ (Hash)
                </label>
                <div className="input-group-custom">
                    <input
                        type="password"
                        className="form-input-custom"
                        value={configuration.Hash || ''}
                        onChange={(e) => onChange('Hash', e.target.value)}
                        placeholder="Введите API ключ"
                        disabled={disabled}
                        autoComplete='new-password'
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">⏱️</span>
                    Таймаут (секунды)
                </label>
                <div className="input-group-custom">
                    <input
                        type="number"
                        className="form-input-custom"
                        value={configuration.Timeout || ''}
                        onChange={(e) => {
                            const value = e.target.value;
                            onChange('Timeout', value ? parseInt(value) : '');
                        }}
                        min="1"
                        placeholder="30"
                        disabled={disabled}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

NagConfiguration.configFields = ['BaseUrl', 'Hash', 'Timeout'];

export default NagConfiguration;